import { isGhostSessionActive } from "context/platformAdminContext.utils";
import { platformRoleAccess } from "helpers/RolesPermission";
import { baseURLImage } from "Utils/utils";

export const FEED_EVENT_IMAGE_MAX_BYTES = 5 * 1024 * 1024;

export const FEED_EVENT_IMAGE_ACCEPT =
  ".jpg,.jpeg,.png,.gif,.webp,image/jpeg,image/png,image/gif,image/webp";

/**
 * Super Admin catalog staff can post events. Ghost sessions use the acting
 * user's token, so management stays on the platform admin session.
 */
export const canManageDashboardEvents = () =>
  platformRoleAccess("platform.catalog.news") && !isGhostSessionActive();

export const hasFormattedText = (html) => {
  const plain = String(html || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

  return plain.length > 0;
};

export const eventImageSrc = (image) => {
  if (!image) {
    return "";
  }

  if (/^https?:\/\//i.test(image)) {
    return image;
  }

  return baseURLImage(image);
};

export const feedEventErrorMessage = (err, fallback) => {
  const errors = err?.response?.data?.errors;
  if (errors && typeof errors === "object") {
    const first = Object.values(errors).flat().find(Boolean);
    if (first) {
      return String(first);
    }
  }

  const message =
    err?.response?.data?.message || err?.response?.data?.error || err?.message;

  return typeof message === "string" && message ? message : fallback;
};
